import type { CSSProperties } from "react";

/** Ticket Information primary — pagination pills (Today / Recent custom DOM pagination) */
export function activityPaginationPageBtnStyle(
  isActive: boolean,
  compact?: boolean,
): CSSProperties {
  const minW = compact ? 28 : 36;
  const h = compact ? 28 : 36;
  return {
    borderRadius: 6,
    border: `1px solid ${isActive ? "#6366f1" : "#e5e7eb"}`,
    backgroundColor: isActive ? "#6366f1" : "#ffffff",
    color: isActive ? "#ffffff" : "#374151",
    fontWeight: isActive ? 600 : 500,
    minWidth: minW,
    height: h,
    padding: "0 8px",
    fontSize: compact ? 11 : 14,
    lineHeight: 1,
  };
}

export function activityPaginationArrowBtnStyle(
  disabled: boolean,
  compact?: boolean,
): CSSProperties {
  const minW = compact ? 28 : 36;
  const h = compact ? 28 : 36;
  return {
    borderRadius: 6,
    border: "1px solid #e5e7eb",
    backgroundColor: disabled ? "#f9fafb" : "#ffffff",
    color: disabled ? "#9ca3af" : "#374151",
    minWidth: minW,
    height: h,
    cursor: disabled ? "not-allowed" : "pointer",
    fontSize: compact ? 11 : 14,
  };
}